import { IMessage } from '../message';

/**
 * @param msgKey Message key
 *
 * @returns
 * A function that can be called with a message and that
 * returns `true` if the key of message equals `msgKey`
 *
 * @example
 * modals.find(messageByKey('successModal'));
 * // returns the modal with key 'successModal'
 */
export function messageByKey(msgKey: string): (message: IMessage) => boolean {
  return (message: IMessage) => msgKey === message.key;
}
